// workstation-fixes.js
// - Abre la ficha técnica por defecto
// - Quita chips blancos residuales
// - Conecta botón "Ver ficha técnica" con scroll suave
document.addEventListener('DOMContentLoaded', function () {
  try {
    var root = document.querySelector('.ws-workstation');
    if (!root) return;

    // details ficha
    var details = root.querySelector('details.specs-details');
    if (details) {
      // abrir por defecto
      details.open = true;
      details.classList.add('fixed-open');
      // marcar aria
      var summary = details.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', 'true');
      // asegurar que el content este visible para lectores
      var content = details.querySelector('.content');
      if (content) content.setAttribute('aria-hidden', 'false');
    }

    // eliminar chip blanco (si aparece)
    var chips = root.querySelectorAll('.spec-btn, .placeholder, .empty-block');
    chips.forEach(function (el) {
      try { el.remove(); } catch (e) { /* ignore */ }
    });

    // "Ver ficha técnica" (botón inferior)
    var openBtn = document.getElementById('open-ficha');
    if (openBtn && details) {
      openBtn.addEventListener('click', function (e) {
        e.preventDefault && e.preventDefault();
        try {
          details.open = true;
          details.classList.add('fixed-open');
          var target = document.getElementById('ficha-content') || details;
          if (target && target.scrollIntoView) {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            // pequeña focus para accesibilidad
            setTimeout(function () { target.setAttribute('tabindex','-1'); target.focus(); }, 450);
          }
        } catch (err) { console && console.warn && console.warn('open-ficha err', err); }
      });
    }

    // Evitar que el tema inserte columnas multi-col en nuestras listas
    var lists = root.querySelectorAll('.three-col ul, .three-col .benef-list, .three-col .uses-grid ul');
    lists.forEach(function (ul) {
      ul.style.columnCount = '1';
      ul.style.WebkitColumnCount = '1';
      ul.style.MozColumnCount = '1';
    });

  } catch (err) {
    console && console.warn && console.warn('workstation-fixes init error', err);
  }
});
